import ApiClient from "./ApiClient"
import SyncResult from "../types/SyncResult"

export const LockTimeLimitApi = {
    apiPath: 'lock-time-limits',

    syncAllByLockingSystemId: async (lockingSystemId: number): Promise<SyncResult> => {
        const params = new URLSearchParams([['lockingSystemId', lockingSystemId.toString()]])

        const result = await ApiClient.get(
            LockTimeLimitApi.apiPath + '/sync/all', { params }
        )

        return result?.data
    },
}

export default LockTimeLimitApi